import styles from './FeatureBlocks.module.css'
import FeatureBlock from './FeatureBlock'

const FeatureBlocks = ({ data }) => {
    return (
        <div className={styles.featureBlocks}>
            {data.map((item, index) => (
                <FeatureBlock
                    key={index}
                    backgroundColor={item.backgroundColor}
                    color={item.color}
                    title={item.title}
                    description={item.description}
                    icon={item.icon}
                    link={item.link}
                    linkText={item.linkText}
                />
            ))}
        </div>
    )
}

export default FeatureBlocks
